<template>
    <div>

      <!--Stable-text-box -->
      <div class="card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">Stable Textbox</div>
          <div class="sub-topic-num">No.1</div>
        </div>
 
        <div class="data-box clearfix" v-show="subTopic1">
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">Label1</div>
            <div class="col-xs-7 data-input-stable">Detail1</div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">Label1</div>
            <div class="col-xs-7 data-input-stable">Detail1</div>
          </div>
        </div>
      </div>
      <!--Stable-text-box -->

      <!--Input-box -->
      <div class="card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">Input Textbox</div>
          <div class="sub-topic-num"></div>
        </div>
 
        <div class="data-box clearfix" v-show="subTopic2">
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">Label1</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" />
            </div>
          </div>
          <div class="data-row clearfix">
            <div class="col-xs-5 data-label">Label1</div>
            <div class="col-xs-7 data-input">
              <input type="text" class="form-control input-text" />
            </div>
          </div>
        </div>
      </div>
      <!--Input-box -->

      <!--Table-box -->
      <div class="card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic3">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">Table Tax</div>
          <div class="sub-topic-num"></div>
        </div>
 
        <div class="data-box clearfix" v-show="subTopic3">
          <div class="table-row">
            <div class="col-xs-12 head-table-left bg-color-skin">ID - Label1</div>
            <div class="col-xs-12 head-table-right bg-color-skin">Tax</div>
            <div class="col-xs-12 head-table-right bg-color-skin">Spouse Tax</div>
          </div>

          <div class="table-row clearfix">
            <div class="col-xs-12 body-table-left color-skin">ID - Label1</div>
            <div class="col-xs-12 body-table-right">
              <div class="data-table-row">
                <div class="col-xs-5 table-label">Label1</div>
                <div class="col-xs-7 table-input">
                  <input type="text" class="form-control input-text" />
                </div>
              </div>
            </div>
            <div class="col-xs-12 body-table-right">
              <div class="data-table-row">
                <div class="col-xs-5 table-label">Label2</div>
                <div class="col-xs-7 table-input">
                  <input type="text" class="form-control input-text" />
                </div>
              </div>
            </div>
          </div>

          <div class="table-row clearfix">
            <div class="col-xs-12 body-table-left color-skin">ID - Label1</div>
            <div class="col-xs-12 body-table-right">
              <div class="data-table-row">
                <div class="col-xs-5 table-label">Label1</div>
                <div class="col-xs-7 table-input">
                  <input type="text" class="form-control input-text" />
                </div>
              </div>
            </div>
            <div class="col-xs-12 body-table-right">
              <div class="data-table-row">
                <div class="col-xs-5 table-label">Label2</div>
                <div class="col-xs-7 table-input">
                  <input type="text" class="form-control input-text" />
                </div>
              </div>
            </div>
          </div>

          <div class="table-row clearfix">
            <div class="col-xs-12 body-table-left color-skin">ID - Label1</div>
            <div class="col-xs-12 body-table-right">
              <div class="data-table-row">
                <div class="col-xs-5 table-label">Label1</div>
                <div class="col-xs-7 table-input">
                  <input type="text" class="form-control input-text" />
                </div>
              </div>
            </div>
            <div class="col-xs-12 body-table-right">
              <div class="data-table-row">
                <div class="col-xs-5 table-label">Label2</div>
                <div class="col-xs-7 table-input">
                  <input type="text" class="form-control input-text" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--Table-box -->

    </div>
</template>

<script>
export default {
  name: 'cardui',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      subTopic3: true,
      app: this.$parent.$parent.$parent
    }
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?86cf43b0